let VERSION_OPTIONS = [
  {
    label: 'stable',
    value: 'stable',
    index: 0,
    isDisabled: false,
  },
  {
    label: 'stable 2024',
    value: 'stable2024',
    index: 2,
    isDisabled: false,
  },
  {
    label: 'stable 2023',
    value: 'stable2023',
    index: 3,
    isDisabled: false,
  },
  { label: 'beta', value: 'beta', index: 4, isDisabled: false },
];

if (window.env.REACT_APP_ENV === 'dev') {
  VERSION_OPTIONS = [...VERSION_OPTIONS, { label: 'dev', value: 'dev', index: 4, isDisabled: false }];
}

const KNOWN_SUBDOMAINS = VERSION_OPTIONS.map((v) => v.value);
    
export { KNOWN_SUBDOMAINS, VERSION_OPTIONS };
